import React, { useEffect, useState } from "react";
import Link from "next/link";
import { DropdownOptions } from "@/types/common";
import { ChevronDown } from "lucide-react";
import MobileNav from "@/components/ui/MobileNav";
import MobileDropDown from "./MobileDropDown";
import CustomSelect from "../my-account/CustomSelect";

export interface MobileFiltersProps {
  sortOptions: DropdownOptions[];
  sortBy: string;
  toggleDropdown: () => void;
  handleSortChange: (option: DropdownOptions) => void;
  yearEventCounts: { year: number; totalEvents: number }[];
  selectedYear: number;
  maxShowYear: number;
  time: string;
  setSelectedYear: (year: number) => void;
  setSortBy: (value: string) => void;
  yearEvent: DropdownOptions[];
  isDropdownOpen: boolean;
  handleYearSelect: (value: string) => void;
}

export default function MobileFilters({
  sortOptions,
  sortBy,
  setSortBy,
  toggleDropdown,
  handleSortChange,
  yearEventCounts,
  selectedYear,
  maxShowYear,
  time,
  setSelectedYear,
  yearEvent,
  isDropdownOpen,
  handleYearSelect,
}: MobileFiltersProps) {
  return (
    <>
      <div className="flex items-center justify-between border-b border-inkBlack/40 pb-10 lg:pb-16">
        <div className="flex flex-col gap-4">
          {time === "past" && (
            <Link
              href="/events"
              className="text-xs hidden md:block font-bold text-inkBlack"
              prefetch={false}
            >
              GO BACK
            </Link>
          )}
          <h1 className="text-5xl md:text-6xl font-medium">
            {time === "past" ? (
              <span className="hidden md:inline">Archived </span>
            ) : (
              ""
            )}{" "}
            Events
            <span className="text-orange">.</span>
          </h1>
        </div>
        {/* <div className="relative hidden lg:block">
          <CustomSelect
            name="Sort By"
            value={sortBy}
            onChange={(value) => setSortBy(value)}
            options={[
              { label: "All", value: "" }, 
              ...(sortOptions?.map((sort: any) => ({
                label: sort.label,
                value: sort.value,
              }))),
            ]}
            searchable={true}
            placeholder="Sort By"
          />
        </div> */}
      </div>
      {time === "past" && (
        <>
          <div className="lg:hidden flex gap-[10px] pb-[10px] pt-5">
            <MobileDropDown
              placeholder="Select Year"
              items={yearEventCounts.map((count) => ({
                label:
                  selectedYear === count.year
                    ? `${count.year} (${count.totalEvents} events)`
                    : `${count.year} (${count.totalEvents} events)`,
                value: count.year.toString(),
              }))}
              initialSelectedItem={
                selectedYear ? selectedYear.toString() : undefined
              }
              // className={`${selectedYear ? 'text-orange border-orange' : 'text-inkBlack/40 border-inkBlack/40'}`}
              isOption={true}
              onSelect={(value) => {
                const year = parseInt(value);
                setSelectedYear(year);
              }}
              // maxOptions={maxShowYear}
              // footerText="View More"
              // footerLink="/events/archived"
            />
            {/* <MobileNav
              placeholder="Select Month"
              items={monthEventCounts}
              isOption={true}
              onSelect={handleMonthSelect}
            /> */}
          </div>
          {/* <MobileNav
            placeholder="Select Format"
            className="lg:hidden"
            items={format}
            isOption={true}
            onSelect={handleFormatSelect}
          /> */}
        </>
      )}
      {time === "upcoming" && (
        <div className="relative mt-5 lg:hidden">
        <CustomSelect
          name="Sort By"
          value={sortBy}
          onChange={(value) => setSortBy(value)}
          options={[
            { label: "All", value: "" }, 
            ...(sortOptions?.map((sort: any) => ({
              label: sort.label,
              value: sort.value,
            }))),
          ]}
          searchable={true}
          placeholder="Sort By"
        />
      </div>
      )}
      {time === "upcoming" && (
        <div className="lg:hidden flex gap-[10px] pb-[10px] pt-5">
          <MobileDropDown
            placeholder="Select Year"
            items={yearEventCounts.map((count) => ({
              label:
                selectedYear === count.year
                  ? `${count.year} (${count.totalEvents} events)`
                  : `${count.year} (${count.totalEvents} events)`,
              value: count.year.toString(),
            }))}
            initialSelectedItem={
              selectedYear ? selectedYear.toString() : undefined
            }
            // className={`${selectedYear ? 'text-orange border-orange' : 'text-inkBlack/40 border-inkBlack/40'}`}
            isOption={true}
            onSelect={(value) => {
              const year = parseInt(value);
              setSelectedYear(year);
            }}
            maxOptions={maxShowYear}
            footerText="View More"
            footerLink="/events/archived"
          />
        </div>
      )}
    </>
  );
}
